import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Machine } from "@interfaces/models/machine.interface";
import { Skill } from "@interfaces/skill.interface";
import { AppSettingsService } from "@services/appSettings.service";
import { MachineService } from "@services/machine.service";
import { SkillService } from "@services/skillService.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "skills-id",
	styleUrls: ["skills-id.css"],
	templateUrl: "skills-id.html"
})
export class SkillsIdAdminComponent {
	headerPrimaryButtons: AdminHeaderButton[] = [];
	item: Skill = new Skill();
	itemId = 0;
	itemType = "Skill";
	machines: Machine[] = [];
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	title: string = "View " + this.itemType;

	constructor(private appSettingsService: AppSettingsService, private router: Router, private toastService: ToastService, private route: ActivatedRoute, private itemService: SkillService, private machineService: MachineService) {
		this.buildButtons("view");
		this.getMachines();

		this.route.params.subscribe((params) => {
			if (params.id != "create") {
				if (params.id.split("_").length > 1) {
					this.itemId = params.id.split("_")[0];
					this.getItem(this.itemId);
					this.edit();
				} else {
					this.itemId = params.id;
					this.getItem(params.id);
				}
			} else {
				this.create();
			}
		});
	}

	buildButtons(mode: string) {
		if (mode == "edit") {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "saveAsNew", text: "Save as New" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "create") {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];
		}
	}

	cancelEditing() {
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Created " + this.itemType);
					this.item = new Skill();
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	displayMachineInDropdown(e: any) { 
		return e === null || e === undefined ? "" : (e.cellNumber === null || e.cellNumber === undefined ? "???" : e.cellNumber) + " - " + e.name;
	}

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}

	getItem(itemId: number) {
		this.itemService.getSingleById(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	getMachines() {
		this.machineService.getAll()
			.subscribe(
				(res: any) => this.machines = res.response.items,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	saveAsNew() {
		const newItem = new Skill();
		newItem.autoGenerateAndEmailCertificate = this.item.autoGenerateAndEmailCertificate;
		newItem.level1 = this.item.level1;
		newItem.level2 = this.item.level2;
		newItem.level3 = this.item.level3;
		newItem.level4 = this.item.level4;
		newItem.machineId = this.item.machineId;
		newItem.name = this.item.name;
		newItem.trainingLengthMonths = this.item.trainingLengthMonths;

		this.itemService.createSingle(newItem)
			.subscribe(
				(res: any) => {
					this.toastService.success("Successfully Created " + this.itemType);
					const newLookupId = res.response.lookupId;

					this.itemService.getSingleByLookupId(newLookupId)
						.subscribe(
							(res: any) => {
								this.router.navigate([`/${this.returnUrl}/${res.response.id}_edit`]);
							},
							(err) => {
								console.log(err);
								this.toastService.error("Something Went Wrong!");
							}
						);

					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	updateItem() {
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => this.toastService.success("Successfully Updated "),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
}